import { message } from 'antd';
import MailerPreviewFrame from './MailerPreviewFrame';
import React, { useState, useEffect } from 'react'
import { Breadcrumb, Spinner } from '../common/atoms';
import { companyMailerApi } from '../../services';
import { successOrFailureToaster } from '../common/atoms/messages';
import {changeTheme, exit_icon, revert} from '../../assets/images'
import TestMailModal from '../modals/TestMailModal';
import { useHistory, useLocation } from 'react-router-dom';
import { handleAppError } from '../handlers';
import { EMAIL_REGEX } from '../../constants/companyMailer';
import PopUpModals from '../modals/PopUpModals';
import UnlayerEmailEditor from './UnlayerEmailEditor';
import { Tooltip } from 'antd';
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';

const GrapesEmailEditor = React.lazy(() => import('./GrapesEmailEditor'));

const LegacyMailConfig = (props) => {
    const history = useHistory();
    const location = useLocation();
    const welcomeMode = location.state?.backPath === '/welcome-mailer';
    const [test, setTest] = useState({mail: '', testMail: false, data: {}});
    const [exitModal, setExitModal] = useState(false);
    const [revertModal, setRevertModal] = useState(false);
    const [data, setData] = useState({
        id: '',
        sender: '',
        subject: '',
        preview: '',
        content: '',
        template_data: '',
        edit: false,
        pageloading: true,
        loadError: false,
        backPath: ''
    })

    useEffect(() => {
        setData((prev) => 
            {return {...prev,
            ...{id: location.state?.id,
                backPath: location.state?.backPath,
            edit: location.state?.show}}})
        getMailerContent(location.state?.id)
    },[])

    const handleMailerError = (err) => {
        if (err?.response?.status === 403) {
            successOrFailureToaster({ message: "You don't have permission to edit this mailer", type: 'fail' });
        } else {
            handleAppError(err);
        }
    }

    const getMailerContent = (id) => {
        setData((prev) => ({ ...prev, pageloading: true, loadError: false }));
        const options = { id: id}
        companyMailerApi.show_mailer(
          options,
          (res) => {
            let data = res.data.mailer;
            let subState = {
                pageloading: false,
                subject: data.subject,
                content: data.content,
                preview: data.preview,
                sender: data.sender,
                template_data: data.template_data
            };
            setData((prev) => {
              return{...prev,...subState}
              })
          },
          (err) => {
            setData((prev) => ({ ...prev, pageloading: false, loadError: true }));
            handleMailerError(err);
          }
        )
      }

      const updateMailer = (subData, check = null) => { 
        const options = { id: data.id , data: subData}
        companyMailerApi.update_mailer(
          options,
          (res) => {
              if(res.data.msg === 'successfully saved' && check === 'save' ){
                let message = welcomeMode ? 'Welcome mailer content saved.' : 'Your theme has been saved successfully'
                successOrFailureToaster({ message, type: 'success'})
                history.goBack()
              }else if(check === 'preview'){
                history.goBack()
              }
              else{
                successOrFailureToaster({message: 'Something went wrong. Try again.', type: 'fail'})
              }
            },
          (err) => handleMailerError(err)
        )
      }

      const sendTest = () => {
        const recipients = [...new Set((test.mail || '').split(',').map((mail) => mail.trim().toLowerCase()))];
        if (recipients.length > 10) {
          message.error('Send a test email to up to 10 recipients.');
          return;
        }
        if(handleValidation(recipients)){
          let remaining = recipients.length;
          let failed = false;
          let failure;
          const complete = (success, err) => {
            if (!success) {
              failed = true;
              if (!failure || err?.response?.status === 403) failure = err;
            }
            remaining -= 1;
            if (remaining) return;
            if (failure) {
              handleMailerError(failure);
            } else if (failed) {
              successOrFailureToaster({message: 'Something went wrong. Try again.', type: 'fail'});
            } else {
              const message = `Test email sent successfully to: ${test.mail.replace(/,\s*/g, ', ')}`;
              successOrFailureToaster({ message, type: 'success'});
              setTest((prev) => ({ ...prev, testMail: false }));
              history.push(data.backPath);
            }
          };
          recipients.forEach((mail) => {
            const options = { id: test.data.id, data: {...test.data, email: mail} }
  
            companyMailerApi.test_mail(
              options,
              (res) => complete(res.data.message === 'success'),
              (err) => complete(false, err)
            )
          })
          }else{
            message.error('Enter a valid email address.')
          }
      }
  
      const handleValidation = (emails) => emails.every((mail) => EMAIL_REGEX.test(mail));

      const undoContent = () => {
        const options = { id: location.state?.id}
        companyMailerApi.revert_to_original(
          options,
          (res) => {
            if(res.data.message === 'success'){
              let message = 'Your theme successfully reverted to original'
              successOrFailureToaster({ message, type: 'success'})
              setRevertModal(!revertModal)
              window.location.reload()
            }else{
              successOrFailureToaster({message: 'Something went wrong. Try again.', type: 'fail'})
            }
          },
          (err) => handleAppError(err)
        )
      }

      const testMailFunc = (e) => {
        let data = test.testMail;
        let subState = {testMail: !data}
        setTest((prevValues) => {
          return{...prevValues,...subState}
        });
      }

      const sentTestMail = (e) => {
        let subState = {testMail: true, data: data}
        setTest((prev) => {
          return{...prev,...subState}
        })
        
      }

      const sanitize = (html) => {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        return doc.innerHTML;
      }

      const updateValue = (data) => {
        let subState = {...data, edit: true, pageloading: false};
        setData((prev) => {
            return{...prev,...subState}
        })
      }

      const prevPage = () => {
        updateMailer({content: data.content, template_data: data.template_data}, 'preview')
      }

      const saveToDraft = (data) => {
        let subState = {content: data, pageloading: false};
        setData((prev) => {
            return{...prev,...subState}
        })
        updateMailer(data, 'save');
      }

      const exitEditor = () => {
        setExitModal(!exitModal);
      }

      const revertToOriginal = () => {
        setRevertModal(!revertModal)
      }

      const html_render = (height) => {
        return(
              <div className='mt-4'>
                <div style={{background: '#F9FAFB'}}>
                  <div className='font-semibold text-base mx-5'><strong className='font-semibold'>From:    </strong>{data.sender}</div>
                  <div className='font-semibold text-base mx-5'><strong className='font-semibold'>Subject:    </strong>{data.subject}</div>
                  <p className='font-normal text-sm mx-4 pl-16'>
                    {data.preview?.length >= 86 ? `${data.preview?.substring(0,86)}...` : data.preview || ''}
                  </p>
                </div> 
                <hr/>
                <div className="container">
                  <MailerPreviewFrame title='Email preview' html={sanitize(data.content)} width='100%' height={height} loading='lazy' />
                </div>
              </div>
        )
      }

      if (data.loadError) {
        return (
          <div role='alert' className='m-6 rounded-ds-lg border border-gray-300 bg-white p-6 text-gray-900'>
            <p>Unable to load this mailer.</p>
            <button onClick={() => getMailerContent(data.id)} className={joinButtonClasses(dsButtonSecondary, 'h-11 px-6')}>Try again</button>
          </div>
        );
      }

      return(
        <Spinner visible={data.pageloading}>
             <Breadcrumb list={[{ text: welcomeMode ? 'Welcome mailer' : 'Pre launch', link: welcomeMode ? '/welcome-mailer' : '/mailer' }, { text:'Configure mail', link:'#' }]} classes='mb-1' />
             { test.testMail &&
            <TestMailModal 
              title='Send a test email'
              description='Send a test to' 
              onClose={testMailFunc} 
              onSave={sendTest} 
              inputVal={(val) => {setTest((prev) => {return{...prev,...{mail: val}}})}} 
            />
          }
              {data.edit ?
              <div>
              <div className='absolute right-0 w-full'>
                <div className='bg-white py-4 px-7 float-left flex flex-row'>
                  <img src={changeTheme} alt='' className='mx-2'/>
                  <p className='font-semibold text-xl my-2' style={{color: '#4B5563'}}>Preview & test</p>
                </div>
                <div className='bg-white py-4 px-7 float-right'>
                  <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0F1115'}
                      key='pink'
                      title={`${!data?.content ? 'Ensure the email content is saved before initiating the teaser 1.' : ''}`}
                      align
                    >
                      <span><button disabled={!data.content} onClick={sentTestMail} className={joinButtonClasses(dsButtonSecondary, 'mx-4 h-11 px-6')}>Send test mail</button></span>
                    </Tooltip>
                  <button onClick ={prevPage} className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}>Exit preview mode</button>
                </div>
              </div> 
              <hr/>
              <div className='flex flex-row pb-12'>
                <div className='mt-32 border-2 mx-16 rounded-md' style={{background: '#F9FAFB', width: '55%'}}>
                  <div className='h-12 flex flex-row py-4 px-2' style={{background: '#E5E7EB'}}>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#9CA3AF'}}></div>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#9CA3AF'}}></div>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#9CA3AF'}}></div>
                  </div>
                    {html_render('900')}
                </div>
                <div className='mt-32 border-2 mx-6 p-6' style={{background: '#E5E7EB', borderRadius: '58px',height: 930, width: 470}}>
                  <div className='flex justify-center py-2 mb-4'>
                    <div className="rounded-xl mx-2 w-3 h-3 font-semibold" style={{background: '#9CA3AF'}}></div>
                    <div className="rounded-xl mx-2 w-24 h-3 font-semibold" style={{background: '#9CA3AF'}}></div>
                  </div>
                  <div className='p-0.5 overflow-hidden' style={{background: '#F9FAFB', borderRadius: '48px',height: '95%'}}>
                    {html_render('750')}
                  </div>
                </div>
              </div>
              </div>:
            <div>
              { exitModal &&
                <PopUpModals 
                title='Exit editor?'
                description={["Changes you have made may not be saved"]}
                onCancel='No'
                onPass='Exit'
                icon={exit_icon}
                onClose={exitEditor}
                onSave={() => { history.push(data.backPath) }}
              />
              }
              { revertModal &&
                <PopUpModals 
                title='Revert to original?'
                description={["Would you like to revert all the changes to the original template? ",<strong>All the changes you made will be lost.</strong>]}
                onCancel='Cancel'
                onPass='Revert'
                icon={revert}
                onClose={revertToOriginal}
                onSave={undoContent}
              />
              }
              <UnlayerEmailEditor
                initialVal={data.template_data} 
                updateValue={updateValue} 
                saveToDraft={saveToDraft}
                exitEditor={exitEditor}
                revertToOriginal={revertToOriginal}
              />
            </div>}
        </Spinner>
    )

}

   

const MailConfig = props => {
  const location = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(location.search);
  const id = query.get('mailer_id') || location.state?.id;
  const paths = { prelaunch: '/mailer', welcome: '/welcome-mailer', benefits: '/benefit-adoption-mailers' };
  const backPath = paths[query.get('from')] || location.state?.backPath || '/mailer';
  useEffect(() => {
    if (!id) {
      history.replace(backPath === '/welcome-mailer' ? '/welcome-mailer' : '/mailer');
      return;
    }
    if (location.state?.initialMailer) {
      const { initialMailer, ...rest } = location.state || {};
      history.replace({ ...location, state: rest });
    }
  }, [id, history]);
  if (!id) return null;
  return query.has('mailer_id') || location.state?.builder
    ? <React.Suspense fallback={<div role="status" className="p-8">Loading mailer editor…</div>}><GrapesEmailEditor key={id} id={id} backPath={backPath} initialMailer={location.state?.initialMailer} /></React.Suspense>
    : <LegacyMailConfig {...props} />;
};

export default MailConfig
